"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Comment;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
const _extractProps = require("~/helpers/extractProps");
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Comment = class Comment {
    static async get(context, commentId, ncMeta = _Noco.default.ncMeta) {
        const comment = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COMMENTS, commentId);
        return comment && new Comment(comment);
    }
    static async listByModel(context, fk_model_id, pagination, ncMeta = _Noco.default.ncMeta) {
        const comments = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COMMENTS, {
            condition: {
                fk_model_id
            },
            orderBy: {
                id: 'asc'
            },
            limit: pagination == null ? void 0 : pagination.limit,
            offset: pagination == null ? void 0 : pagination.offset,
            xcCondition: {
                _or: [
                    {
                        is_deleted: {
                            eq: null
                        }
                    },
                    {
                        is_deleted: {
                            eq: true
                        }
                    }
                ]
            }
        });
        return comments.map((comment)=>new Comment(comment));
    }
    static async list(context, { row_id, fk_model_id }, ncMeta = _Noco.default.ncMeta) {
        const commentList = await ncMeta.knex(_globals.MetaTable.COMMENTS).select(`${_globals.MetaTable.COMMENTS}.*`).where('row_id', row_id).where('fk_model_id', fk_model_id).where(function() {
            this.whereNull('is_deleted').orWhere('is_deleted', '!=', true);
        }).orderBy('created_at', 'asc');
        return commentList.map((comment)=>new Comment(comment));
    }
    static async insert(context, comment, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(comment, [
            'id',
            'fk_model_id',
            'row_id',
            'comment',
            'parent_comment_id',
            'source_id',
            'base_id',
            'fk_model_id',
            'created_by',
            'created_by_email'
        ]);
        if (!insertObj.fk_model_id) _catchError.NcError.tableNotFound(insertObj.fk_model_id);
        if (!insertObj.source_id) {
            const model = await _Model.default.getByIdOrName(context, {
                id: insertObj.fk_model_id
            }, ncMeta);
            insertObj.source_id = model.source_id;
        }
        const res = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COMMENTS, (0, _modelUtils.prepareForDb)(insertObj));
        return res;
    }
    static async update(context, commentId, comment, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(comment, [
            'comment',
            'resolved_by',
            'resolved_by_email'
        ]);
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COMMENTS, (0, _modelUtils.prepareForDb)(updateObj), commentId);
        return Comment.get(context, commentId, ncMeta);
    }
    static async resolve(context, commentId, comment, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(comment, [
            'resolved_by',
            'resolved_by_email'
        ]);
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COMMENTS, (0, _modelUtils.prepareForDb)(updateObj), commentId, {}, true);
        return Comment.get(context, commentId, ncMeta);
    }
    static async delete(context, commentId, ncMeta = _Noco.default.ncMeta) {
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COMMENTS, {
            is_deleted: true
        }, commentId);
        return true;
    }
    static async deleteModelComments(context, fk_model_id, ncMeta = _Noco.default.ncMeta) {
        return ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.COMMENTS, {
            fk_model_id
        });
    }
    static async commentsCount(context, args) {
        const audits = await _Noco.default.ncMeta.knex(_globals.MetaTable.COMMENTS).count('id', {
            as: 'count'
        }).select('row_id').whereIn('row_id', args.ids).where('fk_model_id', args.fk_model_id).where(function() {
            this.whereNull('is_deleted').orWhere('is_deleted', '!=', true);
        }).groupBy('row_id');
        return audits == null ? void 0 : audits.map((a)=>new Comment(a));
    }
    constructor(comment){
        Object.assign(this, comment);
    }
};
